module.exports = __webpack_public_path__ + "img/multi-step-quiz-v4.37aa138b.svg";